import { Link as RouterLink } from 'react-router-dom';
import { Box, BoxProps } from '@mui/material';
import useAuth from 'src/hooks/useAuth';

// ----------------------------------------------------------------------

interface Props extends BoxProps {
  disabledLink?: boolean;
}

export default function Logo({ disabledLink = false, sx }: Props) {
  const { user } = useAuth();
  const logo = (
    <Box sx={{ width: 100, height: 100, ...sx }}>
      <img src="/logo/logo_sempre2.png" alt="" style={{ marginLeft: '-10px' }} />
    </Box>
  );

  if (disabledLink) {
    return <>{logo}</>;
  }

  return <RouterLink to={user ? '/dashboard/app' : '/'}>{logo}</RouterLink>;
}

export function LogoCollapse({ disabledLink = false, sx }: Props) {
  const { user } = useAuth();
  const logoCollapse = (
    <Box sx={{ width: 100, height: 100, ...sx }}>
      <img src="/logo/logo_sempreCollapse.svg" alt="" style={{ margin: '0 auto' }} />
    </Box>
  );

  if (disabledLink) {
    return <>{logoCollapse}</>;
  }

  return <RouterLink to={user ? '/dashboard/app' : '/'}>{logoCollapse}</RouterLink>;
}
